import { Component, ElementRef } from '@angular/core';
// import * as GSAPImport from 'gsap';
import { Observable } from 'rxjs';
// const GSAP = GSAPImport.gsap;

@Component({
  selector: 'app-loading-indicator',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 146.315 25"
      class="pulse"
      [ngClass]="{hide: hideLoading}"
    >
      <g transform="translate(0.105)">
        <g transform="translate(-0.105)">
          <path
            d="M20.41,24.57l.054.108a.776.776,0,0,0,.6.325,1.583,1.583,0,0,0,.488-.108l4.718-2.169a.8.8,0,0,0,.38-.813,6.1,6.1,0,0,1-.38-1.9,7.584,7.584,0,0,1,1.3-3.959c.271-.434.542-.922.922-1.464,1.464-2.223,3.742-5.64,3.8-8.568a7.58,7.58,0,0,0-1.41-4.989L30.822.925a.776.776,0,0,0-.6-.325,1.583,1.583,0,0,0-.488.108L25.02,2.878a.8.8,0,0,0-.38.813,6.1,6.1,0,0,1,.38,1.9,7.584,7.584,0,0,1-1.3,3.959c-.271.434-.542.868-.922,1.464-1.464,2.223-3.742,5.64-3.8,8.568A8.4,8.4,0,0,0,20.41,24.57Z"
            transform="translate(-8.639 -0.275)"
            fill="#ff6200"
          />
          <path
            d="M39.61,23.97l.054.108a.776.776,0,0,0,.6.325,1.583,1.583,0,0,0,.488-.108l4.718-2.169a.8.8,0,0,0,.38-.813,6.1,6.1,0,0,1-.38-1.9,7.584,7.584,0,0,1,1.3-3.959c.271-.434.6-.868.922-1.464,1.464-2.223,3.742-5.64,3.8-8.568A7.58,7.58,0,0,0,50.076.434L50.022.325a.776.776,0,0,0-.6-.325,1.583,1.583,0,0,0-.488.108L44.22,2.278a.8.8,0,0,0-.38.813,6.1,6.1,0,0,1,.38,1.9,7.584,7.584,0,0,1-1.3,3.959c-.271.434-.542.922-.922,1.464-1.464,2.223-3.742,5.64-3.8,8.568A8.263,8.263,0,0,0,39.61,23.97Z"
            transform="translate(-17.427)"
            fill="#ff6200"
          />
          <path
            d="M9.388,15.091c1.464-2.223,3.742-5.64,3.8-8.568a7.58,7.58,0,0,0-1.41-4.989l-.054-.108a.776.776,0,0,0-.6-.325,1.583,1.583,0,0,0-.488.108L5.917,3.378a.8.8,0,0,0-.38.813,6.1,6.1,0,0,1,.38,1.9,7.584,7.584,0,0,1-1.3,3.959c-.271.434-.6.922-.922,1.464C2.23,13.736-.048,17.152-.1,20.08a7.58,7.58,0,0,0,1.41,4.989l.054.108a.776.776,0,0,0,.6.325h0a1.583,1.583,0,0,0,.488-.108l4.718-2.169a.8.8,0,0,0,.38-.813,6.1,6.1,0,0,1-.38-1.9,7.584,7.584,0,0,1,1.3-3.959C8.737,16.122,9.063,15.688,9.388,15.091Z"
            transform="translate(0.105 -0.503)"
            fill="#ff6200"
          />
        </g>
        <g transform="translate(40.136 0.054)">
          <path
            d="M97.093,13.827a6.13,6.13,0,0,1,1.464,4.284v11.28h-3.9V18a2.922,2.922,0,0,0-.488-1.79,1.645,1.645,0,0,0-1.356-.651H91.182a2.544,2.544,0,0,0-1.9.813,3.884,3.884,0,0,0-1.03,2.169V29.337H84.4V18.111a3.215,3.215,0,0,0-.488-1.844,1.56,1.56,0,0,0-1.356-.7H81.041a2.464,2.464,0,0,0-1.952.976A5.2,5.2,0,0,0,78,19.141v10.2H74.1V12.471h3.633v2.115a4.585,4.585,0,0,1,1.627-1.735,3.532,3.532,0,0,1,2.007-.651h1.952a4.01,4.01,0,0,1,2.278.651,4.4,4.4,0,0,1,1.573,1.844,5.312,5.312,0,0,1,1.79-1.844,4.224,4.224,0,0,1,2.223-.651h1.952A5.112,5.112,0,0,1,97.093,13.827Z"
            transform="translate(-74.1 -5.638)"
            fill="#fff"
          />
          <path
            d="M125.373,28.306a4.305,4.305,0,0,1-1.573-3.471V23.643a4.164,4.164,0,0,1,1.627-3.416,6.723,6.723,0,0,1,4.284-1.3h2.115a8.9,8.9,0,0,1,2.007.271,10.363,10.363,0,0,1,1.952.7V17.786a2.247,2.247,0,0,0-.651-1.681,2.374,2.374,0,0,0-1.735-.651h-2.82a2.617,2.617,0,0,0-1.79.542,1.645,1.645,0,0,0-.651,1.356h-3.8a4.583,4.583,0,0,1,1.735-3.742,7.033,7.033,0,0,1,4.555-1.41h2.82a6.518,6.518,0,0,1,4.555,1.518,5.244,5.244,0,0,1,1.735,4.067v11.5H136.11V27.167A6.2,6.2,0,0,1,134.1,28.9a5.107,5.107,0,0,1-2.386.651H129.6A6.158,6.158,0,0,1,125.373,28.306Zm6.508-1.735a4.2,4.2,0,0,0,2.44-.759,3.994,3.994,0,0,0,1.518-2.007v-.813a4.551,4.551,0,0,0-1.627-.759,7.358,7.358,0,0,0-2.223-.271h-2.115a2.529,2.529,0,0,0-1.627.488,1.546,1.546,0,0,0-.651,1.3v.922a1.645,1.645,0,0,0,.651,1.356,2.692,2.692,0,0,0,1.681.488h1.952Z"
            transform="translate(-96.848 -5.638)"
            fill="#fff"
          />
          <path
            d="M159.69,22.326a6.422,6.422,0,0,1-1.79-4.772v-3.9a7.207,7.207,0,0,1,.868-3.633,6.075,6.075,0,0,1,2.386-2.44,6.937,6.937,0,0,1,3.525-.868h2.061A4.6,4.6,0,0,1,168.8,7.2a5.044,5.044,0,0,1,1.681,1.247V.2h3.85V23.844H170.7V21.512a5.306,5.306,0,0,1-1.9,1.9,4.489,4.489,0,0,1-2.386.7H164.3A6.127,6.127,0,0,1,159.69,22.326Zm7.05-1.573a3.153,3.153,0,0,0,2.495-1.193,4.814,4.814,0,0,0,1.247-2.874V13.324a4.479,4.479,0,0,0-1.139-2.386,2.95,2.95,0,0,0-2.169-.922H165a2.971,2.971,0,0,0-2.386,1.03,4.1,4.1,0,0,0-.922,2.711v3.471a3.732,3.732,0,0,0,.813,2.495,2.578,2.578,0,0,0,2.115.922h2.115Z"
            transform="translate(-112.455 -0.146)"
            fill="#fff"
          />
          <path
            d="M196.608,28.894a6.043,6.043,0,0,1-2.44-2.223,5.967,5.967,0,0,1-.868-3.254v-4.5a6.737,6.737,0,0,1,.868-3.471,6.306,6.306,0,0,1,2.44-2.332,7.8,7.8,0,0,1,3.633-.813h2.712a6.813,6.813,0,0,1,4.935,1.79,6.251,6.251,0,0,1,1.844,4.772v3.362H197.2v1.193a2.9,2.9,0,0,0,.813,2.169,3.033,3.033,0,0,0,2.223.813h2.6a3.338,3.338,0,0,0,2.169-.651,2.134,2.134,0,0,0,.813-1.735h3.8a5.073,5.073,0,0,1-1.9,4.121,7.631,7.631,0,0,1-4.989,1.573h-2.549A9.615,9.615,0,0,1,196.608,28.894Zm9.328-9.6v-.488a3.442,3.442,0,0,0-.813-2.386,2.747,2.747,0,0,0-2.115-.922H200.3a2.765,2.765,0,0,0-2.223.976,3.5,3.5,0,0,0-.868,2.495V19.3Z"
            transform="translate(-128.658 -5.684)"
            fill="#fff"
          />
          <path
            d="M229.235,28.135a5.108,5.108,0,0,1-1.735-4.121h3.8A2.213,2.213,0,0,0,232,25.749a2.689,2.689,0,0,0,1.9.651h2.983a3.378,3.378,0,0,0,1.79-.38,1.193,1.193,0,0,0,.651-1.085v-.759a.976.976,0,0,0-.38-.813,2.522,2.522,0,0,0-1.085-.488l-5.8-.976a5.853,5.853,0,0,1-3.091-1.41,3.382,3.382,0,0,1-1.139-2.549V16.8a3.811,3.811,0,0,1,1.681-3.308,7.748,7.748,0,0,1,4.61-1.193h2.712a6.366,6.366,0,0,1,4.338,1.464,4.718,4.718,0,0,1,1.681,3.8h-3.8a2,2,0,0,0-.6-1.464,2.139,2.139,0,0,0-1.573-.542h-2.657a3.464,3.464,0,0,0-1.844.38,1.173,1.173,0,0,0-.651,1.03v.651a.976.976,0,0,0,.38.813,1.989,1.989,0,0,0,1.03.434l6.074,1.085a6.131,6.131,0,0,1,2.983,1.41,3.243,3.243,0,0,1,1.139,2.44v1.247a3.859,3.859,0,0,1-1.735,3.308,7.747,7.747,0,0,1-4.61,1.247h-2.983A6.557,6.557,0,0,1,229.235,28.135Z"
            transform="translate(-144.311 -5.684)"
            fill="#fff"
          />
          <path
            d="M261,4.384a2.33,2.33,0,0,1-.7-1.79A2.411,2.411,0,0,1,261,.8a2.452,2.452,0,0,1,1.844-.7,2.373,2.373,0,0,1,1.844.7,2.33,2.33,0,0,1,.7,1.79,2.411,2.411,0,0,1-.7,1.79,2.452,2.452,0,0,1-1.844.7A2.581,2.581,0,0,1,261,4.384ZM260.9,6.933h3.9V23.8h-3.9Z"
            transform="translate(-159.324 -0.1)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  `,
  styles: [
    `
      :host {
        width: 100%;
        height: 100%;
        background: black;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }

      svg {
        width: 4rem;
      }

      .pulse {
        animation-name: pulse;
        animation-duration: 1s;
        animation-iteration-count: infinite;
      }

      .hide {
        opacity: 0;
        transition: opacity 0.7s;
      }

      @keyframes pulse {
        0% {
          transform: scaleX(1);
        }

        50% {
          transform: scale3d(1.2, 1.2, 1.2);
        }

        100% {
          transform: scaleX(1);
        }
      }
    `
  ]
})
export class LoadingIndicatorComponent {
  hideLoading: boolean;

  constructor(private el: ElementRef) {}

  leave() {
    return new Observable(observer => {
      setTimeout(() => {
        this.hideLoading = true;

        // GSAP.to(this.el.nativeElement, {
        //   height: '0px',
        //   duration: 0.78,
        //   ease: 'power3.in',
        //   onComplete: () => {
        //     observer.next();
        //     observer.complete();
        //   }
        // });
        observer.next();
        observer.complete();
      }, 100);
    });
  }
}
